import React, { useEffect, useRef } from 'react';

import { Spinner } from 'reactstrap';
import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Spin } from 'antd';

import { useTranslation } from "contexts";

const PayerVendor = ({ ...props }) => {
    const { formConfig } = props;
    const formRef = useRef();
    const translate = useTranslation();

    useEffect(() => {
        var formEl = formRef.current ;
        if( formEl ) {
            setTimeout(() => {
                formEl.submit() ;
            }, 100);
        }
    }, [])
    
    return (
        <div className="d-flex justify-content-center" style={{ height: 'calc(100vh - 20px)' }}>
            <Flex justify="center" align="center">
                <Spin indicator={<LoadingOutlined style={{ fontSize: 72 }} spin />} />
            </Flex>
            <form action={formConfig.action} ref={formRef} method="post">
				{
                    Object.keys(formConfig.fields).map((fieldName) => { 
                        let fieldValue = formConfig.fields[fieldName] ;
                        return (
                            <input 
                                key={fieldName}
                                name={fieldName}
                                type="hidden"
                                value={fieldValue}
                            />
                        );
				    })
                }
				<button style={{ display:'none' }} type="submit">{ translate("MiscSubmit") }</button>
			</form>
        </div>
    );
}

export default PayerVendor ;